import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { appContentUrl, storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler } from 'C4';

const trackShare = (type, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj.response);
      APIHandler.trackEvent(appId, email, 'collateral', type, value).then(() => {
      });
    });
  });
};

export default class LinkHandler extends Component {
  constructor(props) {
    super(props);

    this.ChooseFavoritesLinkBehaviour = this.ChooseFavoritesLinkBehaviour.bind(this);
    this.ChooseSellPromoteBehaviour = this.ChooseSellPromoteBehaviour.bind(this);
  }

  ChooseSellPromoteBehaviour() {
    const {
      appId,
      url,
      type,
      UniqueID,
      className,
      children,
      dataOptions,
      dataFancybox,
      dataTrigger,
    } = this.props;

    const objectUrl = `${appContentUrl}${appId}/salesCompanion/${
      typeof url === 'object' ? url[0] : url
    }`;

    // eslint-disable-next-line default-case
    switch (url) {
      case 'travel-itineraries':
        return (
          <Link onClick={() => trackShare('carousel', url)} to={`promote/${url}`} key={UniqueID} className={className}>
            {children}
          </Link>
        );
      case 'itineraries':
        return (
          <Link onClick={() => trackShare('carousel', url)} to={`promote/${url}`} key={UniqueID} className={className}>
            {children}
          </Link>
        );
    }

    switch (type) {
      case 'carousel':
        return (
          <Link onClick={() => trackShare('carousel', url)} to={`sell/${url}`} key={UniqueID} className={className}>
            {children}
          </Link>
        );
      case 'web':
        return (
          <a
            href={url}
            key={UniqueID}
            target="_blank"
            rel="noreferrer noopener"
            className={className}
            onClick={() => trackShare('web', url)}
          >
            {children}
          </a>
        );
      case 'iframe':
        return (
          <a
            data-fancybox={UniqueID}
            data-type="iframe"
            data-options={dataOptions}
            data-src={url}
            href={url}
            key={UniqueID}
            className={className}
            onClick={() => trackShare('web', url)}
          >
            {children}
          </a>
        );
      case 'map':
        return (
          <a
            data-fancybox={UniqueID}
            data-type="iframe"
            data-options={dataOptions}
            data-src="https://taiwan-old.travpromobile.com/map_mobile.php"
            href="https://taiwan-old.travpromobile.com/map_mobile.php"
            key={UniqueID}
            className={className}
            onClick={() => trackShare('map', url)}
          >
            {children}
          </a>
        );
      case 'contact':
        return (
          <Link onClick={() => trackShare('contact', url)} to="/main/promote/contact" key={UniqueID} className={className}>
            {children}
          </Link>
        );
      case 'directory':
        return (
          <Link onClick={() => trackShare('directory', url)} to="/main/directory" key={UniqueID} className={className}>
            {children}
          </Link>
        );
      case 'pdf':
        return <div onClick={() => trackShare('pdf', url)} data-src={`https://stack.travpromobile.com/viewer.php?file=${objectUrl}`} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
      case 'image':
        return (
          <div
            onClick={() => trackShare('image', url)}
            data-src={objectUrl}
            data-fancybox={dataFancybox}
            data-options={dataOptions}
            data-fancybox-trigger={dataTrigger}
            className={className}
            key={UniqueID}
          >
            {children}
          </div>
        );
      case 'multi':
        return (
          <div
            onClick={() => trackShare('multi', url)}
            data-fancybox={UniqueID}
            data-fancybox-trigger={UniqueID}
            data-src={`#${UniqueID}`}
            className={className}
            key={UniqueID}
          >
            {children}
          </div>
        );
      case 'explore':
        return (
          <a
            onClick={() => trackShare('explore', url)}
            data-fancybox={UniqueID}
            data-type="iframe"
            data-options={dataOptions}
            data-src="https://taiwan-old.travpromobile.com/explore_mobile.php"
            href="https://taiwan-old.travpromobile.com/explore_mobile.php"
            key={UniqueID}
            className={className}
          >
            {children}
          </a>
        );
      case 'na':
        return (
            <a
              onClick={() => trackShare('na', url)}
              data-fancybox={UniqueID}
              data-type="inline"
              data-src="Henk"
              key={UniqueID}
              className={className}
            >
              {children}
            </a>
        );
      default:
        return (
          <a
            onClick={() => trackShare('default', url)}
            href={url}
            data-options={dataOptions}
            data-fancybox={dataFancybox}
            data-fancybox-trigger={dataTrigger}
            target=""
            className={className}
            key={UniqueID}
          >
            {children}
          </a>
        );
    }
  }

  ChooseFavoritesLinkBehaviour() {
    const {
      appId,
      url,
      type,
      subType,
      UniqueID,
      className,
      children,
      dataOptions,
      dataFancybox,
      dataTrigger,
    } = this.props;

    const { chapter, page } = this.props.info;

    const objectUrl = `${appContentUrl}${appId}/salesCompanion/${
      typeof url === 'object' ? url[0] : url
    }`;

    // t = Promote or Sell item
    if (type === 't') {
      switch (subType) {
        case 'carousel':
          return (
            <Link to={`sell/${url}`} key={UniqueID} className={className}>
              {children}
            </Link>
          );
        case 'web':
          return (
            <a
              href={url}
              key={UniqueID}
              target="_blank"
              rel="noreferrer noopener"
              className={className}
            >
              {children}
            </a>
          );
        case 'iframe':
          return (
            <a
              data-fancybox={UniqueID}
              data-type="iframe"
              data-options={dataOptions}
              data-src={url}
              href={url}
              key={UniqueID}
              className={className}
            >
              {children}
            </a>
          );
        case 'contact':
          return (
            <Link
              to="/main/promote/contact"
              key={UniqueID}
              className={className}
            >
              {children}
            </Link>
          );
        case 'pdf':
          return (
            <div
              data-src={objectUrl}
              data-fancybox={dataFancybox}
              data-options={dataOptions}
              data-fancybox-trigger={dataTrigger}
              className={className}
              key={UniqueID}
            >
              {children}
            </div>
          );
        case 'image':
          return (
            <div
              data-src={objectUrl}
              data-fancybox={dataFancybox}
              data-options={dataOptions}
              data-fancybox-trigger={dataTrigger}
              className={className}
              key={UniqueID}
            >
              {children}
            </div>
          );
        case 'multi':
          return (
            <div
              data-fancybox={UniqueID}
              data-fancybox-trigger={UniqueID}
              data-src={`#${UniqueID}`}
              className={className}
              key={UniqueID}
            >
              {children}
            </div>
          );
        default:
          return (
            <a
              href={url}
              data-options={dataOptions}
              data-fancybox={dataFancybox}
              data-fancybox-trigger={dataTrigger}
              target=""
              className={className}
              key={UniqueID}
            >
              {children}
            </a>
          );
      }
    }
    // p = Training Content Page
    if (type === 'p') {
      return (
        <Link
          to={`ret/chapter/${chapter}/${page - 1}`}
          className="favorite__button"
          key={UniqueID}
        >
          {children}
        </Link>
      );
    }
    return null;
  }

  render() {
    const { favorites } = this.props;
    return (
      <React.Fragment>
        {favorites
          ? this.ChooseFavoritesLinkBehaviour()
          : this.ChooseSellPromoteBehaviour()}
      </React.Fragment>
    );
  }
}

LinkHandler.propTypes = {
  info: PropTypes.shape({
    chapter: PropTypes.string,
    page: PropTypes.string,
  }),
  appId: PropTypes.number,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.string.isRequired,
  subType: PropTypes.string,
  UniqueID: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  dataOptions: PropTypes.string.isRequired,
  dataFancybox: PropTypes.string.isRequired,
  dataTrigger: PropTypes.string.isRequired,
  favorites: PropTypes.bool,
};

LinkHandler.defaultProps = {
  info: {},
  subType: 't',
  appId: -1,
  url: '#',
  favorites: false,
};
